let order = [];

module.exports.set = (appOrder = []) => order = appOrder;
module.exports.get = () => order;
